<template lang='pug'>
  .linkables.component
    base-modal#link-email( :show='modal' )
      modal-wrapper.max-640( @close='modal = false' )
        template( v-slot:header )
          h4 {{ $t( `Link Your Email/Password` ) }}
        template( v-slot:contents )
          linkable-password-form( :user='user', @password-linked='linked' )

    h2 Use my Google/Facebook account to login

    bf-flex
      bf-flex.centered.email.actionable(
        v-if='!providers.find( p => p.providerId == "password" ) && providers.some( p => p.providerId != "phone" )'
        @click.native='modal = true'
      )
        email-icon

      img.facebook.actionable(
        v-if='!providers.find( p => p.providerId == "facebook.com" )'
        src='/ui/facebook.png'
        @click='link( facebook )'
      )
      img.google.actionable(
        v-if='!providers.find( p => p.providerId == "google.com" )'
        src='/ui/google-plus.png'
        @click='link( google )'
      )
</template>

<script>
  import { firebase } from '@/main'
  import BaseModal from '@/components/modals/base'
  import CloseButton from '@/components/buttons/close'
  import LinkablePasswordForm from '@/components/forms/linkable/password'
  import ModalWrapper from '@/components/modals/wrapper'

  export default {
    name: 'linkables.component',

    components: {
      BaseModal,
      CloseButton,
      LinkablePasswordForm,
      ModalWrapper
    },

    props: {
      user: { type: Object, required: true }
    },

    data() {
      return {
        google: new firebase.auth.GoogleAuthProvider(),
        facebook: new firebase.auth.FacebookAuthProvider(),
        password: new firebase.auth.EmailAuthProvider(),
        linkables: [ 'facebook.com', 'google.com', 'password' ],
        modal: false
      }
    },

    computed: {
      providers() {
        return this.user.providerData
      },

      ids() {
        return this.providers.map( p => p.providerId )
      },

      linkable() {
        return this.linkables.some( linkable => !this.ids.includes( linkable ) )
      }
    },

    methods: {
      link( provider ) {
        this.user.linkWithRedirect( provider )
        .then(  )
        .catch( e => alert( e.message ) )
      },

      linked( usr ) {
        this.modal = false
        this.$emit( "password-linked", usr )
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .email
    background gray
    border-radius 50%
    color white
    height 36px
    width 36px
    margin-left 8px

  .linkables
    h2
      margin 48px 0 24px 0
    .bf-flex
      align-items center
    img
      width 36px
      margin 0 12px
    
</style>